import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const STORAGE_KEY = 'cozey_lang';
const DEFAULT_LANG = 'ar'; // Default to Arabic for first-time visitors (majority Arabic-speaking clientele)

const applyDocumentDir = (lang) => {
  if (lang === 'ar') {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  } else {
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = lang;
  }
};

const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ['en', 'ar', 'tr'].includes(stored)) return stored;
  } catch (e) {
    /* localStorage may be unavailable (SSR/privacy mode) */
  }
  return DEFAULT_LANG;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  // Apply direction/lang on initial mount so RTL kicks in immediately on first paint
  useEffect(() => {
    applyDocumentDir(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    applyDocumentDir(lang);
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* ignore */
    }
  };

  const toggleLanguage = () => {
    const languages = ['en', 'ar', 'tr'];
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    changeLanguage(languages[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
